export default __webpack_public_path__ + "static/media/AS-Colour19-3-400x482.aab7f701.jpg";